import { render, staticRenderFns } from "./DestroyReclamation.vue?vue&type=template&id=017810af&"
import script from "./DestroyReclamation.vue?vue&type=script&lang=js&"
export * from "./DestroyReclamation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports